import { Table } from "antd";
import { get } from "lodash";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../../../utils/utilities";

const TotalTable = (props) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const [state, setState] = useState({
    totalContentExpanded: [],
  });

  const columnsTotal = [
    {
      title: "",
      width: 200,
      fixed: "left",
      render: () => t("projectEstimate.detail.tabs.costEstimation.table.totalProjects"),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
      dataIndex: ["totalAmountValues", "columnValueMap", "AP"],
      width: 100,
      fixed: "left",
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
      dataIndex: ["totalAmountValues", "columnValueMap", "JANUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
      dataIndex: ["totalAmountValues", "columnValueMap", "FEBRUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
      dataIndex: ["totalAmountValues", "columnValueMap", "MARCH"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
      dataIndex: ["totalAmountValues", "columnValueMap", "APRIL"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
      dataIndex: ["totalAmountValues", "columnValueMap", "MAY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
      dataIndex: ["totalAmountValues", "columnValueMap", "JUNE"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
      dataIndex: ["totalAmountValues", "columnValueMap", "JULY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
      dataIndex: ["totalAmountValues", "columnValueMap", "AUGUST"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
      dataIndex: ["totalAmountValues", "columnValueMap", "SEPTEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
      dataIndex: ["totalAmountValues", "columnValueMap", "OCTOBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
      dataIndex: ["totalAmountValues", "columnValueMap", "NOVEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
      dataIndex: ["totalAmountValues", "columnValueMap", "DECEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
      dataIndex: ["totalAmountValues", "columnValueMap", "AS"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
      dataIndex: ["totalAmountValues", "columnValueMap", "TOT"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
  ];

  const expandedRowRender = () => {
    const columnsTotalExpanded = [
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.activityResource"),
        dataIndex: "activity",
        width: 200 + 8, // +8 to compensate the negative margin used by antd for expanded rows
        fixed: "left",
        render: (activity) => {
          let activityTitle = activity;
          if (activity === "work") {
            activityTitle = t("projectEstimate.detail.tabs.costEstimation.table.work");
          } else if (activity === "costs") {
            activityTitle = t("projectEstimate.detail.tabs.costEstimation.table.costs");
          }
          return activityTitle;
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
        dataIndex: "AP",
        width: 100,
        fixed: "left",
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
        dataIndex: "JANUARY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
        dataIndex: "FEBRUARY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
        dataIndex: "MARCH",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
        dataIndex: "APRIL",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
        dataIndex: "MAY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
        dataIndex: "JUNE",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
        dataIndex: "JULY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
        dataIndex: "AUGUST",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
        dataIndex: "SEPTEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
        dataIndex: "OCTOBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
        dataIndex: "NOVEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
        dataIndex: "DECEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
        dataIndex: "AS",
        fixed: "right",
        width: 100,
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
        dataIndex: "TOT",
        fixed: "right",
        width: 100,
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
    ];

    return (
      <Table
        bordered
        dataSource={state.totalContentExpanded}
        columns={columnsTotalExpanded}
        size="small"
        pagination={false}
        scroll={{ x: 1500 }}
        rowClassName={(record) => (record.isFather ? "table-secondary" : "")}
        className="fitExpandedRowInTableWidth"
      />
    );
  };

  const getExpandedRowDataTotal = async (expanded) => {
    let contentExpanded = [];
    const data = props.dataContentTotal[0];
    if (expanded) {
      if (data.totalQuantityValues && data.totalQuantityValues.columnValueMap) {
        const totalQuantityValues = data.totalQuantityValues.columnValueMap;
        totalQuantityValues.activity = "work";
        totalQuantityValues.key = "total-work";
        totalQuantityValues.isHour = true;
        totalQuantityValues.isFather = true;
        totalQuantityValues.children = [];
        if (data.costEstimationKickoffValueView) {
          data.costEstimationKickoffValueView.forEach((cv, i) => {
            if (cv.quantityValues && cv.quantityValues.columnValueMap && cv.serviceType === "HOUR") {
              const childrenValues = cv.quantityValues.columnValueMap;
              childrenValues.activity = cv.activity;
              childrenValues.key = `total-work${i}`;
              childrenValues.isHour = true;
              totalQuantityValues.children.push(childrenValues);
            }
          });
        }
        contentExpanded.push(totalQuantityValues);
      }
      if (data.totalAmountValues && data.totalAmountValues.columnValueMap) {
        const totalAmountValues = data.totalAmountValues.columnValueMap;
        totalAmountValues.activity = "costs";
        totalAmountValues.key = "total-costs";

        totalAmountValues.isFather = true;
        totalAmountValues.children = [];
        if (data.costEstimationKickoffValueView) {
          data.costEstimationKickoffValueView.forEach((cv, i) => {
            if (cv.amountValues && cv.amountValues.columnValueMap) {
              const childrenValues = cv.amountValues.columnValueMap;
              childrenValues.activity = cv.activity;
              childrenValues.key = `total-costs${i}`;
              totalAmountValues.children.push(childrenValues);
            }
          });
        }
        contentExpanded.push(totalAmountValues);
      }
    }

    setState((prevState) => ({
      ...prevState,
      totalContentExpanded: contentExpanded,
    }));
  };

  return (
    <Table
      bordered
      dataSource={props.dataContentTotal}
      columns={columnsTotal}
      size="small"
      pagination={false}
      scroll={{ x: 1500 }}
      expandable={{ expandedRowRender, onExpand: (expanded) => getExpandedRowDataTotal(expanded) }}
      rowClassName="table-primary"
    />
  );
};

export default TotalTable;
